import renderElement from './element';

export default renderElement.bind(null, 'h3');




// WEBPACK FOOTER //
// ../~/idom-util/src/h3.js